import React from 'react'
import '../App.css'
import Bodygestioncomandas from './bodygestioncomandas'
export class Bodyappgestioncomandassbody extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className="flex flex-row space-x-4"> {/* flex-row organiza los elementos horizontalmente */}
                <Bodygestioncomandas/>
            </div>

        );
    }
}